import React from 'react';

import styled from 'styled-components';

import {
    useEditContactConnectionItemDefault,
    useIsContactConnectionItemDefault,
} from '@hooks/API/Contact/UseContactConnections';

import FlexContainer from '@components/Gui/FlexContainer';
import { ContactAddressLine } from '@components/Gui/NwContactInfo';
import NwDropDownMenu from '@components/Gui/NwDropDownMenu';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const DefaultItem = styled.div`
    font-weight: ${(props) => props.isDefault && 'bold'};
`;

const AddressItem = ({ address, readOnly, onEdit, onDelete, contactID }) => {
    const { mutate: onSetItemDefault } = useEditContactConnectionItemDefault();

    const setDefault = () => {
        onSetItemDefault({ itemType: 'address', idItem: address.ID, contactID: contactID });
    };

    const isDefault = useIsContactConnectionItemDefault('address', address.ID, contactID);

    let actions = [
        { name: '', key: 'edit', pinned: true, icon: byPrefixAndName.fasl['pen'], action: onEdit },
        { name: 'set as default', key: 'default', icon: byPrefixAndName.fasl['bookmark'], action: setDefault },
        {
            name: 'delete',
            type: 'delete',
            key: 'delete',
            icon: byPrefixAndName.fasl['trash-alt'],
            confirmationPlacement: 'left',
            action: onDelete,
        },
    ];

    actions = actions.filter((action) => !(action.key === 'default' && isDefault));

    return (
        <FlexContainer justifyContent="space-between">
            <DefaultItem isDefault={isDefault}>
                <ContactAddressLine address={address} />
            </DefaultItem>
            {!readOnly && <NwDropDownMenu size="small" actions={actions} />}
        </FlexContainer>
    );
};

export default AddressItem;
